<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="用户角色管理">
            <a-button slot="extra" type="primary" @click="handleNewRole">新建用户角色</a-button>
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <!--                <a-form-item label="平台编码">-->
                <!--                    <a-input v-model="searchP.platfromcode" placeholder="请输入平台编码"></a-input>-->
                <!--                </a-form-item>-->
                <a-form-item label="选择平台">
                    <a-select v-model="searchP.platfromcode" style="width:160px;" placeholder="请选择">
                        <a-select-option v-for="(item) in platfromlist" :key="item.platfromcode"
                                         v-model="item.platfromcode">
                            {{ item.platfromname + '【' + item.platfromcode + '】' }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="用户名称(昵称)">
                    <a-input v-model="searchP.keyword" placeholder="请输入用户名称(昵称)"></a-input>
                </a-form-item>
                <a-form-item label="用户编码">
                    <a-input v-model="searchP.uid" placeholder="请输入用户编码"></a-input>
                </a-form-item>
                <a-form-item label="角色名称">
                    <a-input v-model="searchP.rolename" placeholder="请输入角色名称"></a-input>
                </a-form-item>

                

                <a-form-item label="状态">
                    <a-select v-model="searchP.userstate" placeholder="" style="width:100px;">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="1">使用</a-select-option>
                        <a-select-option value="2">禁用</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="handleSearch">筛选
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 权限列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="uid">
            <span slot="status" slot-scope="text">{{ statusMap[text] }}</span>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span><router-link
                        :to="{path:'edituserrole',query: {uid: record.uid,platfromcode:record.platfromcode}}">编辑</router-link>
                    </span>

                </div>
            </template>

            <template slot="roles" slot-scope="text">
                <span>
                <a-tag
                    v-for="tag in text.split(',')"
                    :key="tag"
                    :color="'blue'"
                    style="margin-bottom:6px;"
                >
                    {{ tag }}
                </a-tag>
                </span>
            </template>
        </a-table>
        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>


    </div>
</template>
<script>
// 0 - 失败  1-成功 3-处理中 4-未处理
const statusMap = {
    1: '使用',
    2: '禁用',
}
let searchP = {
    rolename: '',//角色名称
    keyword: '',
    userstate: '',
    total: 0,
    pageSize: 0,
    platfromcode: 'FP',
    page: undefined,
    uid: '',
}
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    
    {
        title: '用户名称',
        dataIndex: 'username',
        align: 'center',
        width: 100,
        ellipsises: true
    },
    {
        title: '用户昵称',
        dataIndex: 'nickname',
        align: 'center',
        width: 100,
        ellipsises: true
    },
    {
        title: '用户编码',
        dataIndex: 'uid',
        align: 'center',
        width: 220,
        ellipsises: true
    },
    {
        title: '平台编码',
        dataIndex: 'platfromcode',
        align: 'center',
        width: 100,
        ellipsises: true

    }, 
    // {
    //     title: '角色编码',
    //     dataIndex: 'rolecodes',
    //     align: 'center',
    //     width: 200,

    // }, 
    {
        title: '所属角色',
        dataIndex: 'rolenames',
        align: 'center',
        scopedSlots:{customRender:'roles'},
        width: 180,

    },
    {
        title: '用户状态',
        dataIndex: 'userstate',
        align: 'center',
        width: 80,
        scopedSlots: {customRender: 'status'},
        ellipsises: true
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: {customRender: 'operation'},
        width: 100,
    }

];
const data = [];


export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            statusMap,
            searchP,
            tLoading: true,
            platfromlist: [],
        };
    },
    methods: {
        getSearchPlatFromConfig() {
            let c_params = {
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/selectPlatFromConfig",
                params: c_params
            }).then((res) => {
                this.platfromlist = res.data.data;
                this.getRoleList();

            })
        },

        onDeleteUserRole(item) {
            let c_params = {
                item,
                urlparams: false,
            }
            this.$store.dispatch({
                type: "ums/deleteUserRole",
                params: c_params
            }).then((res) => {
                console.log(res);
                if (res.data.success == '1') {
                    this.message.success('删除成功！');
                } else {
                    this.message.error('删除失败');
                }
                this.getRoleList();
            })
        },
        getRoleList() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/searchUserRolesByUser",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p;
            this.getRoleList();
        },
        handleSearch() {
            this.searchP.page = 1;
            this.getRoleList();
        },

        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.rolename = '';
            this.searchP.uid = '';
            this.searchP.platfromcode = 'FP';
            this.searchP.keyword = '';
            this.getRoleList();
        },
        handleNewRole() {
            if (this.searchP.platfromcode == '') {
                this.message.error('请选择平台')
                return false
            }
            this.$router.push({
                path: "adduserrole",
                query: {id: '', platfromcode: this.searchP.platfromcode}
            });
        },
        handleSubmit(e) {
            e.preventDefault();
            this.searchP.page = 1;
            this.getRoleList()
        },

    },

    components: {},
    mounted() {
        this.getSearchPlatFromConfig();
    }
};
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
</style>
